'use client';

import dynamic from 'next/dynamic';

// ContactForm uses withClientAPI which statically imports Firebase auth.
// Lazy-load so the Firebase chunk is only fetched when a listing includes
// an agent-contact widget.
const ContactForm = dynamic(
  () =>
    import('./contact-form').then(mod => ({
      default: mod.ContactForm,
    })),
  { ssr: true },
);

export { ContactForm as LazyContactForm };
